/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { RouteObject, Routes, Route } from 'react-router-dom';
import { UsersListPage } from './navigation';
import { SidebarWidget } from '@widgets/sidebar-widget-react';
import { vappContainer, VApplication } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { useNavigate } from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { toast } from 'react-hot-toast';

const getAppNavService = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const getDirectorPageRoute = (props: any): RouteObject | any => {
  const srv = getAppNavService();
  const storageSrv = StorageModule?.getInstance();
  const navigate = useNavigate();
  const _handleDropDownItemClick = (item: any) => {
    console.log(`id`, item?.id);
    if (item.id === 'logout') {
      storageSrv.reset('session');
      storageSrv.reset('local');
      navigate(`/`);
    } else {
      toast.success('Coming soon!');
    }
  };

  return {
    path: '/profile/directors',
    element: (
      <SidebarWidget
        {...props}
        notFoundLink={'/404'}
        component={UsersListPage}

        // abilityCheck={srv.abilityCheck.bind(
        //   null,
        //   props?.routes?.Profile?.id,
        //   props.whoami,
        //   'read'
        // )}
      />
    ),
  };
};
